import { createRoot } from 'react-dom/client';
import serverVars from 'server-vars';

import { IntlProvider } from 'dibs-react-intl';

import { Toasts } from '../components/Toasts.tsx';

let isMounted = false;

function mountToasts(): void {
    if (isMounted) {
        return;
    }

    isMounted = true;
    const node = document.createElement('div');
    document.body.appendChild(node);

    createRoot(node).render(
        <IntlProvider locale={serverVars.get('locale')} messages={serverVars.get('messages')}>
            <Toasts />
        </IntlProvider>
    );
}

export { mountToasts };
